import { CommonHelper } from '../../../../common/Helpers/common.helper';
import { ConsoleLoggerService } from '../../../../common/LoggerService/console-logger.service';

import { CounterpartyLimitViewModel, DataEntityState, FourEyeStatus } from './CounterpartyLimits.component.model'
import { Currency, TenorType, Unit } from '../../../../limit-management/TradingLimits.model';
import { Constants } from "../../../../common/constants"
import { UtilityService } from '../../../../common/utility.service';

export class CounterpartyLimitsFourEyeManager {
  //Start FB46162-Pawan Prajapati
  public __oFourEye = {
    LimitValue: null,
    CurrencyId: null,
    UnitId: null,
    TenorTypeId: null,
    NewLimit: null,
    DeleteLimit: null
  }
  public __bIsFourEyeEnabled = false;
  //End FB46162-Pawan Prajapati

  constructor(private __oLogger: ConsoleLoggerService, public __oUtilityService: UtilityService) {
  }

  //Start FB46162-Pawan Prajapati
  public validateFourEyeEdit(oLimit: CounterpartyLimitViewModel) {

  }

  public setDataEntityFieldName(oDatas) {
    try {
      this.__oFourEye.LimitValue = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_LIMIT_VALUE && x.lDataEntityId == 463);
      this.__oFourEye.CurrencyId = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_CURRENCY_ID && x.lDataEntityId == 463);
      this.__oFourEye.UnitId = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_UNIT_ID && x.lDataEntityId == 463);
      this.__oFourEye.TenorTypeId = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_TENOR_TYPE_ID && x.lDataEntityId == 463);
      this.__oFourEye.NewLimit = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_NEW_LIMIT && x.lDataEntityId == 463);
      this.__oFourEye.DeleteLimit = oDatas.find(x => x.DatabaseFieldName == Constants.DATAFIELD_DELETE_LIMIT && x.lDataEntityId == 463);
      this.__bIsFourEyeEnabled = (this.__oFourEye.LimitValue.IsFourEyePolicyEnabled == 1 || this.__oFourEye.CurrencyId.IsFourEyePolicyEnabled == 1
        || this.__oFourEye.UnitId.IsFourEyePolicyEnabled == 1 || this.__oFourEye.TenorTypeId.IsFourEyePolicyEnabled == 1
        || this.__oFourEye.NewLimit.IsFourEyePolicyEnabled == 1 || this.__oFourEye.DeleteLimit.IsFourEyePolicyEnabled == 1);
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while setDataEntityFieldName function.');
    }
  }

  public createRows(oCurrencies: Currency[], oUnits: Unit[], oTenorTypes: TenorType[], oDataSource: CounterpartyLimitViewModel[], oApiDataSource: CounterpartyLimitViewModel[]) {
    try {
      var oGridDataSource = [];
      let bIsNextRow = false;
      oDataSource.forEach(oLimit => {
        if (oLimit.EntityState != 3 && (oLimit.FourEyeRequestStatus > FourEyeStatus.Unchanged || oLimit.FourEyeRequestTempStatus > FourEyeStatus.Unchanged)) {
          oLimit.IsNextRow = bIsNextRow;//for alternative color
          oGridDataSource.push(oLimit);

          let oFourEyeRequestItem = CommonHelper.clone(oApiDataSource.find(k => k.lCounterpartyLimitId == oLimit.lCounterpartyLimitId));
          oFourEyeRequestItem.lParentCounterpartyLimitId = oLimit.lCounterpartyLimitId;
          oFourEyeRequestItem.lCounterpartyLimitId = Constants.FourEyeRowId + Math.floor(1000 + Math.random() * 9000);
          oFourEyeRequestItem.TradingEntityName = '';

          if (oLimit.FourEyeRequestStatus != FourEyeStatus.Added) {
            oFourEyeRequestItem.TenorTypeName = '';
            const sProposedCurrencyId = oFourEyeRequestItem.DataValues.find(k => k.UnVerifiedDataEntityWithFields && k.UnVerifiedDataEntityWithFields.find(x => x.lDataEntityFieldNameId == this.__oFourEye.CurrencyId.lDataEntityFieldNameId && x.Status != 0 && oLimit.FourEyeRequestStatus == FourEyeStatus.Modified))?.UnVerifiedDataEntityWithFields.find(z => z.lDataEntityFieldNameId == this.__oFourEye.CurrencyId.lDataEntityFieldNameId && z.Status != FourEyeStatus.Unchanged).DataValue;
            oFourEyeRequestItem.CurrencyName = oCurrencies.find(x => x.lCurrencyId == sProposedCurrencyId)?.CurrencyName;
            const sProposedUnitId = oFourEyeRequestItem.DataValues.find(k => k.UnVerifiedDataEntityWithFields && k.UnVerifiedDataEntityWithFields.find(x => x.lDataEntityFieldNameId == this.__oFourEye.UnitId.lDataEntityFieldNameId && x.Status != 0 && oLimit.FourEyeRequestStatus == FourEyeStatus.Modified))?.UnVerifiedDataEntityWithFields.find(z => z.lDataEntityFieldNameId == this.__oFourEye.UnitId.lDataEntityFieldNameId && z.Status != FourEyeStatus.Unchanged).DataValue;
            oFourEyeRequestItem.UnitName = oUnits.find(x => x.lUnitId == sProposedUnitId)?.UnitName
          }
          if (oLimit.FourEyeRequestTempStatus != FourEyeStatus.Added) {
            const sProposedTenorTypeId = oFourEyeRequestItem.TempDataValues?.find(k => k.UnVerifiedDataEntityWithFields && k.UnVerifiedDataEntityWithFields.find(x => x.lDataEntityFieldNameId == this.__oFourEye.TenorTypeId.lDataEntityFieldNameId && x.Status != 0 && oLimit.FourEyeRequestTempStatus == FourEyeStatus.Modified))?.UnVerifiedDataEntityWithFields.find(z => z.lDataEntityFieldNameId == this.__oFourEye.TenorTypeId.lDataEntityFieldNameId && z.Status != FourEyeStatus.Unchanged).DataValue;
            oFourEyeRequestItem.TempLimitTenorTypeName = oTenorTypes.find(x => x.lTenorTypeId == sProposedTenorTypeId)?.TenorTypeName;;
          }

          if (oLimit.FourEyeRequestTempStatus == FourEyeStatus.Added) {
            oLimit.IsTempLimitAllocated = false;
          }
          if (oFourEyeRequestItem.IsTempLimitAllocated && oFourEyeRequestItem.FourEyeRequestTempStatus == FourEyeStatus.Unchanged) {
            oFourEyeRequestItem.IsTempLimitAllocated = false;
          }

          this.onUpdateLimitvalue(oFourEyeRequestItem.DataValues, oLimit, Constants.FOUR_EYE_REQUEST_STATUS_PROPERTY);
          this.onUpdateLimitvalue(oFourEyeRequestItem.TempDataValues, oLimit, Constants.FOUR_EYE_REQUEST_STATUS_TEMP_PROPERTY);

          this.setTempStartEndDate(oFourEyeRequestItem);

          this.setTitleForPendingApproval(oFourEyeRequestItem);

          oFourEyeRequestItem.IsNextRow = bIsNextRow;
          if (oLimit.LimitTypeName == Constants.VOLUME && oLimit.FourEyeRequestStatus == FourEyeStatus.Modified && (!(this.__oFourEye.UnitId.IsFourEyePolicyEnabled==1 && oFourEyeRequestItem.UnitName)  && (this.__oFourEye.LimitValue.IsFourEyePolicyEnabled == 1 && oFourEyeRequestItem.DataValues.filter(k => k.LimitValue != null).length == 0))) {
            oLimit.FourEyeRequestStatus = FourEyeStatus.Unchanged;
          } else {
            oGridDataSource.push(oFourEyeRequestItem);
            bIsNextRow = !bIsNextRow;
          }
        }
        else {
          oGridDataSource.push(oLimit);
        }
      });
      return oGridDataSource;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while createRows four-eye function.');
    }
  }

  private setTempStartEndDate(oLimit) {
    try {
      if (oLimit.IsTempLimitAllocated) {
        var oLimitTempDataValues: any = oLimit.TempDataValues.filter(d => d.LimitValue != null);
        if (oLimitTempDataValues && oLimitTempDataValues.length > 0) {
          oLimit.TemporaryLimitFromDate = new Date(Math.min(...oLimitTempDataValues.map(z => new Date(z.TempLimitStartDate))));
          oLimit.TemporaryLimitToDate = new Date(Math.max(...oLimitTempDataValues.map(z => new Date(z.TempLimitEndDate))));
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while setTempStartEndDate four-eye function.');
    }
  }

  private onUpdateLimitvalue(oDataValues, oLimit, sStatusProp) {
    try {
      oDataValues?.forEach(oDataValue => {
        if (oLimit[sStatusProp] != FourEyeStatus.Added) {
          oDataValue.LimitValue = null;
        }
        if (oDataValue.UnVerifiedDataEntityWithFields && oDataValue.UnVerifiedDataEntityWithFields.length > 0 && oLimit[sStatusProp] == FourEyeStatus.Modified) {
          let oUnVerifiedDataEntityWithField = oDataValue.UnVerifiedDataEntityWithFields.find(k => k.lDataEntityFieldNameId == this.__oFourEye.LimitValue.lDataEntityFieldNameId);
          if (oUnVerifiedDataEntityWithField && oUnVerifiedDataEntityWithField.DataValue) {
            if (oLimit.LimitTypeName == Constants.VOLUME) {
              var oLimitValues = oUnVerifiedDataEntityWithField.DataValue.split('-');
              if (oLimitValues[0] && !oLimit.IsBuy)
                oDataValue.LimitValue = !this.__oUtilityService.IsNullOrEmpty(oLimitValues[0]) ? Number(oLimitValues[0]) : oLimitValues[0];
              if (oLimitValues[oLimitValues.length - 1] && oLimit.IsBuy)
                oDataValue.LimitValue = !this.__oUtilityService.IsNullOrEmpty(oLimitValues[oLimitValues.length - 1]) ? Number(oLimitValues[oLimitValues.length - 1]) : oLimitValues[oLimitValues.length - 1];
            } else {
              oDataValue.LimitValue = !this.__oUtilityService.IsNullOrEmpty(oUnVerifiedDataEntityWithField.DataValue) ? Number(oUnVerifiedDataEntityWithField.DataValue): oUnVerifiedDataEntityWithField.DataValue;
             
            }
          }
        }
      });
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while onUpdateLimitvalue four-eye function.');
    }
  }

  private setTitleForPendingApproval(oFourEyeRequestItem: CounterpartyLimitViewModel) {
    try {
      oFourEyeRequestItem.TradingCounterpartyName = Constants.PENDING_APPROVAL_ROW_TEXT;
      if (oFourEyeRequestItem.FourEyeRequestStatus == FourEyeStatus.Added) {
        oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.NEW_LIMIT_LABEL}`;
      } else if (oFourEyeRequestItem.FourEyeRequestTempStatus == FourEyeStatus.Added) {
        oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.NEW_TEMP_LIMIT_LABEL}`;
      } else if (oFourEyeRequestItem.FourEyeRequestStatus == FourEyeStatus.Deleted) {
        oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.DELETE_LIMIT_LABEL}`;
      } else if (oFourEyeRequestItem.FourEyeRequestTempStatus == FourEyeStatus.Deleted) {
        oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.DELETE_TEMP_LIMIT_LABEL}`;
      } else if (oFourEyeRequestItem.FourEyeRequestStatus == FourEyeStatus.Modified && oFourEyeRequestItem.FourEyeRequestTempStatus == FourEyeStatus.Modified) {
        oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.MULTIPLE_LABEL}`;
      } else if (oFourEyeRequestItem.FourEyeRequestStatus == FourEyeStatus.Modified) {
        if (oFourEyeRequestItem.DataValues.find(k => k.LimitValue)) {
          oFourEyeRequestItem.TradingCounterpartyName = Constants.PENDING_APPROVAL_ROW_TEXT;
        } if (oFourEyeRequestItem.DataValues.find(k => k.LimitValue) && (oFourEyeRequestItem.CurrencyName || oFourEyeRequestItem.UnitName)) {
          oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.MULTIPLE_LABEL}`;
        }
      } else if (oFourEyeRequestItem.FourEyeRequestTempStatus == FourEyeStatus.Modified) {
        if (oFourEyeRequestItem.TempDataValues.find(k => k.LimitValue)) {
          oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.TEMP_LIMIT_VALUE_CHANGE_LABEL}`;
        } if (oFourEyeRequestItem.TempDataValues.find(k => k.LimitValue) && oFourEyeRequestItem.TempLimitTenorTypeName) {
          oFourEyeRequestItem.TradingCounterpartyName = `${Constants.PENDING_APPROVAL_ROW_TEXT}: ${Constants.MULTIPLE_LABEL}`;
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while setTitleForPendingApproval four-eye function.');
    }
  }
  

  public isFourEyeRow(oData) {
    try {
      return (oData.FourEyeRequestStatus > FourEyeStatus.Unchanged || oData.FourEyeRequestTempStatus > FourEyeStatus.Unchanged) && String(oData.lCounterpartyLimitId).indexOf(Constants.FourEyeRowId) == 0;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while isFourEyeRow four-eye function.');
    }
  }

  //#region Style for 4Eye policy rows
  public setStyle(oEvent) {
    try {
      if (oEvent.data.FourEyeRequestStatus > 0 || oEvent.data.FourEyeRequestTempStatus > 0) {
        oEvent.rowElement.style.backgroundColor = oEvent.data.IsNextRow ? Constants.FOUR_EYE_FIRST_BG : Constants.FOUR_EYE_SECOND_BG;
        oEvent.rowElement.style.pointerEvents = 'none';
        const hiddenCells = oEvent.rowElement.children;
        [...hiddenCells].forEach(cell => {
          if(cell.classList.contains('dx-treelist-sticky-column-right')) {
            cell.style.pointerEvents = 'auto';
          }
        });
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while setStyle four-eye function.');
    }
  }

  public updateRowsStyle(iRowIndex: number, iColumnIndex: number) {
    try {
      let oTreeList = document.getElementsByClassName('dx-treelist-rowsview')[0];
      if (oTreeList) {
        let oRow: any = oTreeList.getElementsByClassName('dx-data-row')[iRowIndex];
        if (oRow) {
          let oTd: any = oRow.getElementsByTagName('td')[iColumnIndex];
          if (oTd && oTd.innerText.indexOf(Constants.PENDING_APPROVAL_ROW_TEXT) >= 0) {
            oTd.style.fontWeight = 'bold';
            let oExtraSpaceEles: any = oTd.getElementsByClassName('dx-treelist-empty-space');
            if (oExtraSpaceEles && oExtraSpaceEles.length > 0) {
              for (var oExtraSpaceEle of oExtraSpaceEles) {
                oExtraSpaceEle.remove();
              }
            }
          }
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while updateRowsStyle four-eye function.');
    }
  }
  //#endregion
  //End FB46162-Pawan Prajapati
}
